// Sample data for the reseller Partner Console and New Client Setup — there
// is no reseller API yet, so these screens run on this until one exists.
// Replace each export with the real request when the backend lands.

export interface ResellerClient {
  id: string;
  name: string;
  plan: string;
  addedOn: string; // ISO date
}

export const SAMPLE_CLIENTS: ResellerClient[] = [
  { id: "c1", name: "Meridian Bank Nigeria", plan: "Enterprise", addedOn: "2026-06-02" },
  { id: "c2", name: "Coca Cola", plan: "Growth", addedOn: "2026-05-18" },
  { id: "c3", name: "Item Secure", plan: "Growth", addedOn: "2026-04-27" },
  { id: "c4", name: "Lagos Telecom", plan: "Starter", addedOn: "2026-03-09" },
];

export const SAMPLE_METRICS = {
  totalProfiles: 3_200_000,
  revenue: 30_000,
  revenueCurrency: "USD",
  eventsProcessed: 1_240_000,
  connectedSources: 3,
  activeDestinations: 5,
};

export const INDUSTRIES = ["Automotive", "Banking", "Education", "Healthcare", "Insurance", "Retail", "Telecom"];

export const CLIENT_ROLES = ["Admin", "Customer Support", "Marketing", "Sales"];

export const COUNTRY_STATES: Record<string, string[]> = {
  Nigeria: ["Abuja (FCT)", "Enugu", "Kaduna", "Kano", "Lagos", "Ogun", "Oyo", "Rivers"],
  India: ["Delhi", "Gujarat", "Karnataka", "Kerala", "Maharashtra", "Tamil Nadu", "Telangana", "West Bengal"],
  Ghana: ["Ashanti", "Central", "Eastern", "Greater Accra", "Northern", "Western"],
  Kenya: ["Kiambu", "Kisumu", "Mombasa", "Nairobi", "Nakuru"],
};
